import { render } from "./FormSteps.vue?vue&type=template&id=462b10ee"
import script from "./FormSteps.vue?vue&type=script&lang=js"
export * from "./FormSteps.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__